var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[_c('header',[_c('p',[_c('i',{staticClass:"iconfont icon-warning",attrs:{"aria-hidden":"true"}}),_vm._v(" 温馨提示，请在微信中打开本页面。")])]),_vm._v(" "),_c('img',{attrs:{"src":require("./../../static/image/qrcode.png")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a410cfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Qrcode.vue
// module id = null
// module chunks = 